import axios from 'axios';
import Cookies from "js-cookie";
import {
  MessageBox,
  Message
} from 'element-ui'

import {
  getToken
} from '@/utils/auth'
// 创建axios实例
const service = axios.create({

  // baseURL: 'http://192.168.0.172:1001', // api 的 base_url
  // baseURL: 'http://47.118.16.150:1001', // api 的 base_url
  // baseURL: 'https://20.104.19.45:1001', // api 的 base_url
  baseURL: 'https://epluscanada.com',

  // baseURL:'/api',
})
// request拦截器
service.interceptors.request.use(
  config => {

    if (getToken()) {
      config.headers['Authorization'] = getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
    }
    config.headers['Content-Type'] = 'application/json'
    return config
  },
  error => {
    // Do something with request error
    //console.log(error) // for debug
    Promise.reject(error)
  }
)

// response 拦截器
service.interceptors.response.use(
  response => {
    const code = response.status;
    if (response.status < 200 && response.status > 300) {
      Message({
        message: response.data.message || 'Error',
        type: 'error',
        duration: 5 * 1000
      })
      // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
      return Promise.reject(new Error(response.data.message || 'Error'))
    } else {
      if (response.status == 201) {
        Message({
          message: '操作成功',
          type: 'success',
          duration: 5 * 1000
        })
      }
      // if (response.status == 200) {
      //   Message({
      //     message: '操作成功',
      //     type: 'success',
      //     duration: 5 * 1000
      //   })
      // }
      if (response.status == 202) {
        Message({
          message: response.data.message,
          type: 'success',
          duration: 5 * 1000
        })
      }
      return response.data
    }
  },
  error => {
    let code = 0;
    try {
      code = error.response.status
    } catch (e) {
      if (error.toString().indexOf('Error: timeout') !== -1) {
        Message({
          message: '网络请求超时',
          type: 'error',
          duration: 5000
        })
        return Promise.reject(error)
      }
    }
    if (code == 401 || code == 402) {

      localStorage.clear();
      Cookies.remove("logistics_accessToken");
      Cookies.remove("logistics_refreshToken");
      Cookies.remove("logistics_user");
      console.log(4011111);
      window.location.href='https://adminportal.shuyu-global.com/login?login=1&jumpLogin=1'
      // location.reload()
      // this.$router.push({path:'/login'});
    }
    if (code == 500) {
      Message({
        message: '接口报错啦',
        type: 'error',
        duration: 5000
      })

    }

    if (code == 420) {
      Message({
        message: error.response.data.message,
        type: 'error',
        duration: 5 * 1000
      })
    }
    return Promise.reject(error)
  }
)
export default service



// WEBPACK FOOTER //
// ./src/utils/request.js